module.exports = __webpack_public_path__ + "r-v3/img/crown_yellow.8b13f739.svg";